<ng-template #fetching>
    <div class="fetching">
        <app-loading-dots></app-loading-dots>
    </div>
</ng-template>

<div class="wrapper" [class.no-icon]="!showIcon">
    <ng-container *ngIf="timeLeft; else fetching">
        <div class="icon" *ngIf="showIcon">
            <app-svg-icon aria-hidden="true" iconName="delivery"></app-svg-icon>
        </div>
        <div class="countdown text text-bold" *ngIf="timeLeft! | timeRemaining: showCounter | async as timeRemaining">
            <ng-container *ngIf="showCounter && timeRemaining.onTimeForSameDayDelivery">
                <span
                    *ngIf="status === 'Idle'"
                    [innerHTML]="'sameDayDelivery.countDown' | translateSafe : { timeLeft: timeRemaining.time | customTimer, zipCode } | safe: 'html'"
                ></span>
                <span
                    *ngIf="status === 'Valid'"
                    [innerHTML]="'sameDayDelivery.validations.validZipCode' | translateSafe : { timeLeft: timeRemaining.time | customTimer, zipCode } | safe: 'html'"
                ></span>
                <span
                    *ngIf="status === 'Invalid'"
                    [innerHTML]="'sameDayDelivery.validations.invalidZipCode' | translateSafe : { timeLeft: timeRemaining.time | customTimer, zipCode } | safe: 'html'"
                ></span>
            </ng-container>

            <span
                *ngIf="!showCounter"
                [innerHTML]="
                    'sameDayDelivery.afterTimeOver'
                        | translateSafe: { deliveryCutoffTime: timeRemaining.time | date: 'HH' }
                        | safe: 'html'
                "
            ></span>
        </div>
        <app-tooltip *ngIf="showTooltip" class="tooltip">{{
            'sameDayDelivery.tooltipText' | translateSafe: { deliveryCutoffTime: timeLeft | timeLimit | date: 'HH' }
        }}</app-tooltip>
    </ng-container>
</div>
